import React from "react";
import PropTypes from "prop-types";

import { UIEmptyState } from "../../../../../../ui";
import { clx } from "../../../../../../../utils/Helpers";

import "./EventPayrollSectionEmptyState.scss";

const EventPayrollSectionEmptyState = ({
  tone,
  icon,
  title,
  description,
  actionLabel,
  actionIcon,
  onAction,
  actionVariant,
}) => (
  <UIEmptyState
    title={title}
    description={description || undefined}
    icon={icon}
    classNames={{
      root: clx(
        "event-payroll-generate__section-empty-box",
        `event-payroll-generate__section-empty-box--${tone}`,
        description &&
          "event-payroll-generate__section-empty-box--with-description",
      ),
    }}
    actionLabel={actionLabel}
    actionIcon={actionIcon}
    onAction={onAction}
    actionButtonProps={{
      appearance: "outline",
      variant: actionVariant,
      size: "small",
    }}
  />
);

EventPayrollSectionEmptyState.propTypes = {
  tone: PropTypes.oneOf(["destructive", "success", "muted"]).isRequired,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  actionIcon: PropTypes.node,
  onAction: PropTypes.func,
  actionVariant: PropTypes.string,
};

EventPayrollSectionEmptyState.defaultProps = {
  description: "",
  actionLabel: "",
  actionIcon: null,
  onAction: undefined,
  actionVariant: undefined,
};

export default EventPayrollSectionEmptyState;
